'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createColumnWithChildren = undefined;

var _lodash = require('lodash');

var _undoRedoTransactionManager = require('../../utils/undoRedo/undoRedoTransactionManager');

var _elementActions = require('../elementActions');

var _elementMoveActions = require('../elementMoveActions');

var _selectionActions = require('../selection/selectionActions');

var _analytics = require('../../analytics');

var _columnConstants = require('../../../common/columns/columnConstants');

var _boardConstants = require('../../../common/boards/boardConstants');

// Constants


// Actions
// Lib
var createColumnWithChildren = exports.createColumnWithChildren = function createColumnWithChildren(_ref) {
    var location = _ref.location,
        content = _ref.content,
        childIdArray = _ref.childIdArray,
        _ref$sync = _ref.sync,
        sync = _ref$sync === undefined ? true : _ref$sync,
        _ref$transactionId = _ref.transactionId,
        transactionId = _ref$transactionId === undefined ? (0, _undoRedoTransactionManager.getNewTransactionId)() : _ref$transactionId;
    return function (dispatch, getState) {
        (0, _analytics.analyticsEvent)('created-column-cmd-drop');

        // Create the new column
        var columnElementId = dispatch((0, _elementActions.createElement)({
            elementType: _columnConstants.COLUMN_TYPE,
            location: location,
            content: content,
            sync: sync,
            transactionId: transactionId
        }));

        var moves = childIdArray.map(function (id) {
            return {
                id: id,
                location: {
                    parentId: columnElementId,
                    section: _boardConstants.BOARD_SECTIONS.INBOX,
                    position: { index: 0 }
                }
            };
        });

        dispatch((0, _elementMoveActions.moveMultipleElements)({ moves: moves, transactionId: transactionId }));

        (0, _lodash.defer)(function () {
            return dispatch((0, _selectionActions.startEditingElement)({ id: columnElementId }));
        });

        return { columnElementId: columnElementId, transactionId: transactionId };
    };
};

// Utils


//////////////////
// WEBPACK FOOTER
// ./src/client/element/column/columnActions.js
// module id = 1964
// module chunks = 0